import { ItemType, ItemTypeMapper } from "@/@types/flows/emailTemplates/items";
import {
  buttonDefaultBody,
  footerDefaultBody,
  htmlDefaultBody,
  imageDefaultBody,
  textDefaultBody,
} from "@/app/flows/emailTemplates/utils/TemplateItemFactory/defaults";

export abstract class TemplateItemFactory {
  static create<T extends ItemType>(type: T): ItemTypeMapper[T] {
    if (type === ItemType.Text) return textDefaultBody() as ItemTypeMapper[T];
    if (type === ItemType.Image) return imageDefaultBody() as ItemTypeMapper[T];
    if (type === ItemType.Button) return buttonDefaultBody() as ItemTypeMapper[T];
    if (type === ItemType.Html) return htmlDefaultBody() as ItemTypeMapper[T];
    if (type === ItemType.Footer) return footerDefaultBody() as ItemTypeMapper[T];

    throw new Error(`Type ${type} does not exists`);
  }
}
